import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    title: "Sign Up",
    description:
      "Create your profile and tell us about your skills, interests, and goals.",
    icon: "https://cdn.lordicon.com/ndydpcaq.json",
  },
  {
    title: "Choose Your Role",
    description:
      "Select from multiple roles based on your expertise and what you bring to the ecosystem.",
    icon: "https://cdn.lordicon.com/lecprnjb.json",
  },
  {
    title: "Connect with Others",
    description:
      "Network with founders, investors, mentors, and other professionals in your field.",
    icon: "https://cdn.lordicon.com/gqzfzudq.json",
  },
  {
    title: "Scale Up",
    description:
      "Access resources, funding opportunities, and mentorship to grow your business.",
    icon: "https://cdn.lordicon.com/yrxnwkni.json",
  },
];

const HowItWorks = () => {
  return (
    <>
      {/* Lordicon script */}
      <script src="https://cdn.lordicon.com/lordicon.js"></script>

      <section className="bg-gray-50 px-4 py-16 md:py-20 lg:py-24">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            How It Works
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-xl mx-auto mb-12">
            Our platform simplifies the journey from idea to successful startup through these four simple steps.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="flex justify-center mb-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <lord-icon
                      src={step.icon}
                      trigger="loop"
                      delay="2000"
                      style={{ width: "40px", height: "40px" }}
                      colors="primary:#004a99"
                    ></lord-icon>
                  </div>
                </div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {step.title}
                </h4>
                <p className="text-gray-600 text-sm md:text-base">
                  {step.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorks;
